<div class="truncate" [title]="supplierAddress().street">{{ supplierAddress().street }}</div>
<div class="truncate" [title]="formattedAddressInfo()">{{ formattedAddressInfo() }}</div>

@let countryName = supplierAddress().countryName ?? supplierAddress().countryCode;
<div class="truncate" [title]="countryName">{{ countryName }}</div>
